/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreNrsViewerAliases {
  ACTION_INACTIVATE_SCORE_NRS = 'action-inactivate-score-nrs',
  ACTION_NEW_SCORE_NRS = 'action-new-score-nrs',
  ACTION_REFERENCE_SCORE_NRS = 'action-reference-score-nrs',
  CHECKBOX_IE_WEIGHT_LOSS = 'checkbox-ie-weight-loss',
  CHECKBOX_REDUCED_FEEDING = 'checkbox-reduced-feeding',
  CHECKBOX_UTI = 'checkbox-uti',
  FIELD_AGE = 'field-age',
  FIELD_DISEASE_SEVERITY_DOMAIN = 'field-disease-severity-domain',
  FIELD_EVALUATION_DATE = 'field-evaluation-date',
  FIELD_HEIGHT = 'field-height',
  FIELD_IE_WEIGHT_LOSS = 'field-ie-weight-loss',
  FIELD_IMC = 'field-imc',
  FIELD_NOTE = 'field-note',
  FIELD_NUTRITIONAL_STATUS_DOMAIN = 'field-nutritional-status-domain',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_PUNCTUATION = 'field-punctuation',
  FIELD_REDUCED_FEEDING = 'field-reduced-feeding',
  FIELD_RESULT_NRS = 'field-result-nrs',
  FIELD_USUAL_WEIGHT = 'field-usual-weight',
  FIELD_UTI = 'field-uti',
  FIELD_WEIGHT = 'field-weight',
  FIELD_WEIGHT_LOSS = 'field-weight-loss',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_SCORE_NRS_VIEWER = 'form-score-nrs-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_EVALUATION_DATE = 'input-evaluation-date',
  LAYOUT_SCORE_NRS_VIEWER = 'layout-score-nrs-viewer',
  TEXT_AGE = 'text-age',
  TEXT_DISEASE_SEVERITY_DOMAIN = 'text-disease-severity-domain',
  TEXT_HEIGHT = 'text-height',
  TEXT_IMC = 'text-imc',
  TEXT_NOTE = 'text-note',
  TEXT_NUTRITIONAL_STATUS_DOMAIN = 'text-nutritional-status-domain',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_PUNCTUATION = 'text-punctuation',
  TEXT_RESULT_NRS = 'text-result-nrs',
  TEXT_USUAL_WEIGHT = 'text-usual-weight',
  TEXT_WEIGHT = 'text-weight',
  TEXT_WEIGHT_LOSS = 'text-weight-loss',
}
export { ScoreNrsViewerAliases };
